module.exports = __webpack_public_path__ + "static/img/coupon_bg.a849fcae.png";